<template>
  <o-form-group
    :form-state="formState"
    :label="label"
    :message="errorMessages"
    :nolabel="nolabel"
    :type="{ 'is-danger': hasError }"
  >
    <vue-editor
      :class="input_class"
      v-bind="$attrs"
      v-bind:value="value"
      v-if="!_is_readonly"
      v-on="inputListeners"
      :editorOptions="editorSettings"
      :editorToolbar="editorToolbar"
      :customModules="modules"
      ref="htmledit"
    >
    </vue-editor>

    <span v-html="value" v-if="_is_readonly"></span>
  </o-form-group>
</template>

<script>
import FormComponentMixin from "@/vue-ocom/mixins/form_component_mixin";
import OFormGroup from "@/vue-ocom/components/forms/OFormGroup";
import ImageResize from "quill-image-resize";
import { ImageDrop } from "quill-image-drop-module";

import { VueEditor, Quill } from "vue-quill2-editor";
import BetterTable from "quill-better-table";
import TableUI from "quill-table-ui";
import "quill/dist/quill.snow.css";
import "quill-better-table/dist/quill-better-table.css";
import "quill-table-ui/dist/index.css";

export default {
  name: "OxHtmlArea",
  components: { OFormGroup, VueEditor },
  mixins: [FormComponentMixin],
  computed: {
    modules() {
      return [
        {
          alias: "modules/imageDrop",
          module: ImageDrop,
        },
        { alias: "modules/imageResize", module: ImageResize },
        { alias: "modules/better-table", module: BetterTable },
        { alias: "modules/tableUI", module: TableUI },
      ];
    },
    editorSettings() {
      return {
        modules: {
          table: false,
          "modules/tableUI": true,
          "modules/better-table": {
            operationMenu: {
              items: {
                unmergeCells: {
                  text: "Another unmerge cells name",
                },
              },
            },
          },
          "modules/imageDrop": true,
          "modules/imageResize": {},
        },
        keyboard: {
          bindings: BetterTable.keyboardBindings,
        },
      };
    },
    editorToolbar() {
      return [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          {
            align: "",
          },
          {
            align: "center",
          },
          {
            align: "right",
          },
          {
            align: "justify",
          },
        ],
        ["blockquote", "code-block"],
        [
          {
            list: "ordered",
          },
          {
            list: "bullet",
          },
          {
            list: "check",
          },
        ],
        [
          {
            indent: "-1",
          },
          {
            indent: "+1",
          },
        ], // outdent/indent
        [
          {
            color: [],
          },
          {
            background: [],
          },
        ], // dropdown with defaults from theme
        ["link", "image", "table"],
        ["clean"], // remove formatting button
      ];
    },
  },
  methods: {},
};
</script>

<style>
.ql-container.ql-snow {
  background: white;
}
.ql-toolbar.ql-snow {
  background: #fdfdfd;
}
.ql-editor > table {
  width: 100%;
  border: 1px solid #b4b4b4b4;
  border-collapse: collapse;
}
.ql-editor td,
.ql-editor th {
  border: 1px solid #b4b4b4b4;
}
</style>
